import { render, staticRenderFns } from "./TabChangePassword.vue?vue&type=template&id=6a1d6733&"
import script from "./TabChangePassword.vue?vue&type=script&lang=js&"
export * from "./TabChangePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports